import React from 'react';
import { useTranslation } from '../../i18n';
import SectionTag from '../common/SectionTag';
import Button from '../common/Button';

const Adhesion = () => {
  const { t } = useTranslation();

  const steps = [
    { num: '01', titleKey: 'step1_title', descKey: 'step1_desc' },
    { num: '02', titleKey: 'step2_title', descKey: 'step2_desc' },
    { num: '03', titleKey: 'step3_title', descKey: 'step3_desc' },
  ];

  return (
    <section className="bg-ofd-slate px-4 md:px-10 py-20 text-center" id="adhesion">
      <div className="max-w-4xl mx-auto">
        <SectionTag className="text-ofd-yellow border-ofd-yellow">{t('adhesion_tag')}</SectionTag>
        <h2 className="font-playfair text-3xl md:text-4xl font-bold text-white">
          {t('adhesion_title')}
        </h2>
        <p className="text-white/65 max-w-xl mx-auto">{t('adhesion_desc')}</p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-0.5 mt-12 mb-12">
          {steps.map((step, index) => (
            <div key={index} className="p-10 bg-white/5 relative">
              {index < steps.length - 1 && (
                <div className="hidden md:block absolute right-0 top-1/2 -translate-y-1/2 text-ofd-yellow text-2xl z-10">
                  →
                </div>
              )}
              <div className="font-playfair text-5xl font-black text-white/5 leading-none mb-2">
                {step.num}
              </div>
              <h4 className="text-ofd-yellow text-sm font-semibold mb-2">{t(step.titleKey)}</h4>
              <p className="text-white/55 text-sm">{t(step.descKey)}</p>
            </div>
          ))}
        </div>

        <Button href="#contact" variant="primary">{t('adhesion_btn')}</Button>
      </div>
    </section>
  );
};

export default Adhesion;